<template>
  <div class="form-group">
    <label>{{config.name}} <span v-if="config.required">*</span></label>
    <div v-for="(upload, i) in uploads" :key="i">
      <div class="d-flex  align-items-center">
        <div class="w-1/4 p-2">
          <CriteriaUploadFilePreview :file="upload.file" />
        </div>
        <div class="flex-grow-1 p-2">
          <input type="text" class="form-control" :placeholder="$t('Image caption')" v-on:input="updateCaption(i, $event)">
          <input type="hidden" readonly class="form-control-plaintext"
                 :value="upload.file">
        </div>
        <div class="p-2">
          <a href class="text-danger"
                  v-on:click.prevent="deleteUpload(i)">
            <svg class="w-6 h-6" style="width: 20px; height: 20px" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </a>
        </div>
      </div>
      <div class="invalid-feedback"
           :class="{'d-block' : (Array.isArray(errors[i])) }"
           v-if="errors.length > 0 && (Array.isArray(errors[i])) " v-cloak>
        {{ errors[i][0] }}
      </div>
    </div>

    <input type="file" ref="inputFile" accept="image/*" v-on:change="addFile" class="form-control-file" :disabled="!canAddUpload">

    <div class="invalid-feedback" :class="{'d-block' : errors.length > 0 && !Array.isArray(errors[0])}"  v-if="errors.length > 0 && !Array.isArray(errors[0])" v-cloak>
      {{ errors[0] }}
    </div>
  </div>
</template>

<script setup>
import { computed, ref, useTemplateRef } from "vue";
import CriteriaUploadFilePreview from "@/components/frontend/review/CriteriaUploadFilePreview.vue";

const props = defineProps({
  config: Object,
  errors: Array,
})

const emit = defineEmits(['change']);
const uploads = ref([]);
const inputFileRef = useTemplateRef('inputFile');

const canAddUpload = computed(() => {
  return props.config?.properties?.max_files ? parseInt(props.config.properties.max_files) > uploads.value.length : true;
})

const addFile = (e) => {
  uploads.value.push({
    'caption' : '',
    'file': e.target.files[0],
  });
  e.target.value = ''; // Reset the input value to allow re-uploading the same file
  emitChange();
}
const updateCaption = (i, e) => {
  uploads.value.splice(i, 1,  {
    ...uploads.value[i],
    'caption' : e.target.value,
  });
  emitChange();
}
const deleteUpload = (i) => {
  uploads.value.splice(i, 1);
  emitChange();
}
const emitChange = () => {
  emit('change', uploads.value);
}


</script>

<style scoped>

</style>